import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const BannerText = styled.span `
  font-family: 'CiscoSans Thin';
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  align-self: center;
  font-size: 2.4rem;
  font-weight: 100;
`;
export function Banner({ title }) {
    return (_jsx(BannerText, { children: _jsx("span", { dangerouslySetInnerHTML: { __html: title } }) }));
}
